import React from 'react';
import { TrendingUpIcon, UsersIcon, BarChart3Icon, SettingsIcon, DollarSignIcon, RefreshCwIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}
function ServiceCard({
  icon,
  title,
  description
}: ServiceCardProps) {
  return <div className="bg-white p-8 rounded-lg shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-114">
      <div className="flex items-center justify-center w-16 h-16 bg-blue-100 rounded-lg mb-6" data-id="element-115">
        {icon}
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-116">{title}</h3>
      <p className="text-gray-600 leading-relaxed" data-id="element-117">{description}</p>
    </div>;
}
export function ServicesSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language];
  return <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-118">
      <div className="max-w-7xl mx-auto" data-id="element-119">
        <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4 text-center" data-id="element-120">
          {t.services.title}
        </h2>
        <p className="text-xl text-gray-600 mb-12 text-center max-w-3xl mx-auto" data-id="element-121">
          {t.services.subtitle}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-122">
          <ServiceCard icon={<TrendingUpIcon className="w-8 h-8 text-blue-600" data-id="element-124" />} title={t.services.items.strategic.title} description={t.services.items.strategic.desc} data-id="element-123" />

          <ServiceCard icon={<UsersIcon className="w-8 h-8 text-blue-600" data-id="element-126" />} title={t.services.items.business.title} description={t.services.items.business.desc} data-id="element-125" />

          <ServiceCard icon={<BarChart3Icon className="w-8 h-8 text-blue-600" data-id="element-128" />} title={t.services.items.market.title} description={t.services.items.market.desc} data-id="element-127" />

          <ServiceCard icon={<SettingsIcon className="w-8 h-8 text-blue-600" data-id="element-130" />} title={t.services.items.operations.title} description={t.services.items.operations.desc} data-id="element-129" />

          <ServiceCard icon={<DollarSignIcon className="w-8 h-8 text-blue-600" data-id="element-132" />} title={t.services.items.financial.title} description={t.services.items.financial.desc} data-id="element-131" />

          <ServiceCard icon={<RefreshCwIcon className="w-8 h-8 text-blue-600" data-id="element-134" />} title={t.services.items.change.title} description={t.services.items.change.desc} data-id="element-133" />
        </div>
      </div>
    </section>;
}